// extracted by mini-css-extract-plugin
export default {"container_footer":"Footer_container_footer__Xct87"};